var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-node.js
// module id = 342
// module chunks = 1